import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { UserService, User } from './user.service';
import { AmplifyControllerService } from './amplify-controller.service';
import { MessageService, MessageLogout, MessageCognitoInit, MessageLicenseLoading, MessageAppInitialStep, MessageTokenHasExpired, MessageCheckTokenHasExpired, MessageCordovaBackground, MessageWindowOnFocus } from './message.service';
import { ChromeExtService } from './chrome-ext.service';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UtilService } from './util.service';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root'
})
export class CognitoService {

  public isLoggedIn = false;
  private lastUserEmail;
  private debounceTimer: any = null;

  constructor(
    private storageService: StorageService, public userService: UserService,
    private amplifyControllerService: AmplifyControllerService,
    private messageService: MessageService,
    private chromeExtService: ChromeExtService,
    private router: Router, private httpClient: HttpClient, private utilService: UtilService) {
    this.messageService.getMessage().subscribe(message => {
      if (message.name === MessageLogout) {
        this.logout();
      } else if (message.name === MessageCognitoInit) {
        console.log("MessageCognitoInit");
        this.init();
      } else if (message.name === MessageCheckTokenHasExpired) {
        this.checkTokenHasExpired();
      } else if (message.name === MessageCordovaBackground) {
        if (message.data.state == 'yes') {
        } else {
          this.checkLoginSessionOnForeground();
        }
      }
    });
    this.lastUserEmail = '';
    // if (!(AppService.isAndroid() || AppService.isIOS())) {
    if (!(AppService.isAndroid() || AppService.isIOS())) {
      window.onfocus = () => {
        console.log("window on focus");
        this.messageService.sendMessage({ name: MessageWindowOnFocus });
        this.isUserLoggedIn()
          .then(isLoggedIn => {
            // console.log('isLogin: ', isLoggedIn, ' email: ', this.lastUserEmail, ' user service email: ', this.userService.getUser().email);
            if (isLoggedIn) {
              const user = this.userService.getUser()
              const email = user ? user.email : '';
              if (this.lastUserEmail !== email) {
                const hasReload = storageService.read('reload');
                if (!hasReload) {
                  storageService.write('reload', '1');
                  if (AppService.isAndroid() || AppService.isIOS()) {
                    window.location.replace("./index.html");
                  } else {
                    window.location.reload();
                  }
                } else {
                  storageService.remove('reload');
                  this.logout();
                }
              } else {
                storageService.remove('reload');
              }
            } else {
              this.messageService.sendMessage({ name: MessageCheckTokenHasExpired });
            }
            // else if (!isLoggedIn && this.lastUserEmail) {
            //   // return this.logout().then(() => {
            //   //   this.messageService.sendMessage({ name: MessageTokenHasExpiredForWeb });
            //   // });
            //   // this.logout();
            //   // console.log("router url", this.router.url);
            //   // if (this.router.url === '/edu/user') {
            //   //   this.router.navigate(['/']);
            //   // }
            // }
          });
      };
    }
  }
  // this.refreshUserAfterOneDaySingleUse();
  // this.reLoginAfterRefreshTokenExpired();

  // private refreshUserAfterOneDaySingleUse() {
  //   const oneDay = 1000 * 60 * 60 * 24;
  //   // const fiveMin = 1000 * 60 * 5;
  //   setInterval(() => {
  //     this.init();
  //   }, oneDay);
  // }

  private checkLoginSessionOnForeground() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(async () => {
      if (!window['isAppOnline']) {
        console.warn('You are currently offline.');
        return;
      }

      try {
        const userSession = await this.amplifyControllerService.getSession();
        if (!userSession) {
          console.warn('Failed to get user session');
        }
      } catch (err) {
        console.error('Error during session check:', err);
      }
    }, 6000); // 6000ms is for the iOS/Android detect Network(setInterval: 3000ms)
    // setTimeout(() => {
    //   let lastDateStr = localStorage.getItem('NrCheckSessionDate');
    //   if (lastDateStr == null) {
    //     // this.init(true);
    //     localStorage.setItem('NrCheckSessionDate', new Date().toUTCString());
    //     return;
    //   }
    //   let lastLoginDate = new Date(lastDateStr);
    //   let drr = Math.abs(new Date().getTime() - lastLoginDate.getTime());
    //   let day = Math.round(drr / (24 * 60 * 60 * 1000));
    //   if (day > 1) {
    //     this.init(true);
    //     localStorage.setItem('NrCheckSessionDate', new Date().toUTCString());
    //   }
    // }, 6000); // 6000ms is for the iOS/Android detect Network(setInterval: 3000ms)
  }

  private reLoginAfterRefreshTokenExpired() {
    let lastDateStr = localStorage.getItem('NrLoginDate');
    if (lastDateStr == null) {
      return;
    }
    let lastLoginDate = new Date(lastDateStr);
    let drr = Math.abs(new Date().getTime() - lastLoginDate.getTime());
    let day = Math.round(drr / (24 * 60 * 60 * 1000));
    if (day > 30) {
      this.logout();
    }
  }

  public getEmailFromAuthenticatedUser(authenticatedUser) {
    if (!authenticatedUser)
      return '';

    if (authenticatedUser.attributes && authenticatedUser.attributes['email']) {
      return authenticatedUser.attributes['email'];
    }
    else if (authenticatedUser['signInUserSession'] &&
      authenticatedUser['signInUserSession']['idToken'] &&
      authenticatedUser['signInUserSession']['idToken']['payload'] &&
      authenticatedUser['signInUserSession']['idToken']['payload']['email']) {
      return authenticatedUser['signInUserSession']['idToken']['payload']['email'];
    }
    else {
      return '';
    }
  }

  public async isUserLoggedIn() {
    // console.log('isLogin')
    try {
      const Auth = await this.amplifyControllerService.getAuth();
      const user = await Auth.currentAuthenticatedUser();

      const authenticatedUserEmail = this.getEmailFromAuthenticatedUser(user);
      if (authenticatedUserEmail) {
        this.lastUserEmail = authenticatedUserEmail;
      }
      //refresh session to ensure tokens are not expired
      const session = await Auth.currentSession();
      return true;
    } catch (err) {
      return false;
    }
  }

  public checkTokenHasExpired(reload = false) {
    this.isUserLoggedIn()
      .then(isLoggedIn => {
        // return this.amplifyControllerService.getSession()
        //   .then(session => {
        //     if (!session) {
        //       throw new Error('Session is not available');
        //     }
        if ((navigator && navigator.onLine) && isLoggedIn === false && (this.getIsLoggedIn() === true || reload)) {
          // alert("Token is expired!");
          this.messageService.sendMessage({ name: MessageTokenHasExpired });
        } else {
          this.messageService.sendMessage({ name: MessageAppInitialStep });
        }
      });
    // })
    // .catch(error => {
    //   console.error(error);
    //   this.messageService.sendMessage({ name: MessageAppInitialStep });
    // });
  }

  public async init(reload = false) {
    console.log("cognito init");
    // let isLoggedIn = await this.isUserLoggedIn()
    const currentUserInfo = this.userService.getUserInfoFromLocalStorage();
    let userInfo: User = null;
    if (currentUserInfo && currentUserInfo.id) {
      userInfo = {
        'id': currentUserInfo.id,
        'username': currentUserInfo.username,
        'nickname': currentUserInfo.name,
        'email': currentUserInfo.userid,
        'license': null
      };
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }

    console.log('this.userService ', this.userService)
    this.userService.setUser(userInfo)
      .then(user => {
        if (!(AppService.isAndroid() || AppService.isIOS())) {
          if (userInfo) {
            this.chromeExtService.notifyExtToLogIn(user.license['num']);
          }
        }
        this.messageService.sendMessage({ name: MessageLicenseLoading, data: { state: false } });
      });
    // if (AppService.isAndroid() || AppService.isIOS()) {
    setTimeout(() => {
      this.checkTokenHasExpired(reload);
    }, 1000);
    // } else {
    //   this.messageService.sendMessage({ name: MessageAppInitialStep });
    // }
  }

  public loginIOS(): Promise<any> {
    return this.goToIOSAuthUrl('login-service/index.html?redir=ios')
      .catch(function (err) {
        console.log(err);
      });
  }

  public loginAndroid(): Promise<any> {
    return this.goToIOSAuthUrl('login-service/index.html?redir=android')
      .catch(function (err) {
        console.log(err);
      });
  }

  public login(): Promise<any> {
    // TODO: confirm redir for mobile
    return this.goToAuthUrl('/login-service/login?redir=pw&dest=online')
      .catch(function (err) {
        console.log(err);
      });
  }

  public loginEdu(): Promise<any> {
    // TODO: confirm redir for mobile
    return this.goToAuthUrl('/login-service/login?redir=edu&dest=team-management/edu')
      .catch(function (err) {
        console.log(err);
      });
  }

  public logoutgoogle() {
    // ios
    return new Promise((resolve, reject) => {
      let loginProvider = localStorage.getItem('LoginProvider');
      if (loginProvider && loginProvider === 'federated') {
        (<any>window).cordova.plugins.ttsplugin.coolMethod(
          ['federatedlogout'], res => {
            //alert(res);
            if (res === 'ok') {
              resolve('ok');
            }
            reject();
          }, err => {
            reject();
          });
      } else {
        resolve('ok');
      }
    });

  }
  public logout(): Promise<any> {

    return this.logoutgoogle().then(res => {
      return this.amplifyControllerService.getAuth()
        .then(Auth => {
          return Auth.signOut()
        })
        .then(data => {
          this.chromeExtService.notifyExtToLogOut();
          this.lastUserEmail = '';
          this.storageService.write('NAPersonal-isLog', 0);
          this.storageService.write('NAPersonal-userinfo', null);
          this.storageService.write('pw-license', null);
          localStorage.removeItem('pw-iot-policy');
          this.storageService.write('edu-license', null);

          localStorage.removeItem('NAComm-isLog');
          localStorage.removeItem('NaCommAdminEmail');
          localStorage.removeItem('LogNaUserInfo');
          localStorage.removeItem('NaUserInfo');


          localStorage.removeItem('NAWebreader-isLog');
          localStorage.removeItem('NAWebreader-userinfo');

          localStorage.removeItem('NASoftware-isLog');
          localStorage.removeItem('NASoftware-userinfo');

          let plusVoice = localStorage.getItem('pw-plusVoice');
          if (plusVoice && plusVoice.includes("cloned")) {
            localStorage.removeItem('pw-plusVoice');
          }
          this.setIsLoggedIn(false);
          this.userService.clearUser();

          // ios
          localStorage.removeItem('LoginProvider');
          // localStorage.removeItem('NaCordovaPremPaid');
          // localStorage.removeItem('NaCordovaPlusPaid');
          return Promise.resolve();
        })
        .catch(err => console.log(err));
    });


  }

  public signUpIOS(): Promise<any> {
    // TODO: confirm redir for mobile
    return this.goToIOSAuthUrl('login-service/index.html?redir=ios&jumpto=signup')
      .catch(function (err) {
        console.log(err);
      });
  }

  public signUpAndroid(): Promise<any> {
    // TODO: confirm redir for mobile
    return this.goToIOSAuthUrl('login-service/index.html?redir=android&jumpto=signup')
      .catch(function (err) {
        console.log(err);
      });
  }

  public signUp(): Promise<any> {
    // TODO: confirm redir for mobile
    return this.goToAuthUrl('/login-service/signup?redir=pw&dest=online')
      .catch(function (err) {
        console.log(err);
      });
  }

  public changePassword(oldPassword: string, newPassword: string): Promise<any> {
    let auth;
    return this.amplifyControllerService.getAuth()
      .then(Auth => {
        auth = Auth;
        return auth.currentAuthenticatedUser()
      })
      .then(user => {
        return auth.changePassword(user, oldPassword, newPassword);
      })
      .then(data => {
        console.log("change password data", data);
        return Promise.resolve(data);
      })
      .catch(err => {
        console.log("change password err", err)
        return Promise.reject()
      });
  }

  public forgotPassword(username: string): Promise<any> {
    return this.amplifyControllerService.getAuth()
      .then(Auth => {
        return Auth.forgotPassword(username.trim().toLowerCase())
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  public confirmResetPassword(username: string, code: string, newPassword: string): Promise<any> {
    return this.amplifyControllerService.getAuth()
      .then(Auth => {
        return Auth.forgotPasswordSubmit(username.trim().toLowerCase(), code.trim(), newPassword)
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  public updateNickname(nickname: string): Promise<any> {
    let auth;
    return this.amplifyControllerService.getAuth()
      .then(Auth => {
        auth = Auth;
        return Auth.currentAuthenticatedUser()
      })
      .then(user => {
        return auth.updateUserAttributes(user, { nickname });
      });
  }

  private accountHasLinkedIdentities(authenticatedUser): boolean {
    if (!authenticatedUser)
      return false;

    if (authenticatedUser['signInUserSession'] &&
      authenticatedUser['signInUserSession']['idToken'] &&
      authenticatedUser['signInUserSession']['idToken']['payload'] &&
      authenticatedUser['signInUserSession']['idToken']['payload']['cognito:username'] &&
      authenticatedUser['signInUserSession']['idToken']['payload']['cognito:username'].startsWith('Google')) {
      return false;
    }

    if (authenticatedUser['signInUserSession'] &&
      authenticatedUser['signInUserSession']['idToken'] &&
      authenticatedUser['signInUserSession']['idToken']['payload'] &&
      authenticatedUser['signInUserSession']['idToken']['payload']['identities']) {
      return true;
    }

    return false
  }

  deleteLinkedAccounts(): Promise<any> {
    return this.amplifyControllerService.getAuth()
      .then(Auth => {
        return Auth.currentSession()
      })
      .then(session => {
        const url = this.utilService.getEndpoint('ssoApi') + '/user';

        const headers = {
          'Content-Type': 'application/json'
        };

        headers['Authorization'] = session.getIdToken().getJwtToken();
        return this.httpClient.delete(url, { headers }).toPromise()
      })
      .then(response => {
        console.log('deleteUser response: ', response);
        // TODO cache getUserOrgGroupListAndRole res in this service?
        if (!response['error'])
          return this.logout()
        else (response['error'])
        return Promise.reject(response['message']);
      })
      .then(_ => {
        return Promise.resolve();
      })
      .catch(err => {
        console.log('deleteUser err', err);
        if (err && err.error['errorCode'] !== undefined && err.error['errorCode'] !== '') {
          return Promise.reject(err);
        }
        else {
          return Promise.reject();
        }
      });
  }

  public deleteAccount() {
    return this.amplifyControllerService.getAuth()
      .then(Auth => {
        return Auth.currentAuthenticatedUser()
      })
      .then(user => new Promise((resolve, reject) => {
        console.log('user ', user);
        if (this.accountHasLinkedIdentities(user)) {
          console.log('accountHasLinkedIdentities')
          return this.deleteLinkedAccounts()
            .then(() => {
              resolve(null);
            })
        }
        else {
          return user.deleteUser(error => {
            if (error) {
              return reject(error);
            } else {
              return this.logout()
                .then(() => {
                  resolve(null);
                });
            }
          });
        }
      }))
      .catch(function (err) {
        console.log('deleteAccount ', err);
        return Promise.reject(err);
      });
  }

  public goToAuthUrl(redir: string): Promise<any> {
    return Promise.resolve()
      .then(function () {
        const domainParts = window.location.href.split('\/online');
        const domain = domainParts[0];
        const url = domain + redir;
        // window.location.replace(url);
        window.location.href = url;
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  public goToIOSAuthUrl(redir: string): Promise<any> {
    return Promise.resolve()
      .then(function () {
        const domain = '';
        const url = domain + redir;
        window.location.replace(url);
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  public getIsLoggedIn() {
    return this.isLoggedIn;
  }

  public setIsLoggedIn(val: boolean) {
    this.isLoggedIn = val;
  }

  public getAuthIdToken(): Promise<string> {
    return this.amplifyControllerService.getAuth()
      .then(Auth => {
        return Auth.currentSession();
      })
      .then((userSession) => {
        const idToken = userSession.getIdToken().getJwtToken();
        return Promise.resolve(idToken);
      })
      .catch(() => {
        return Promise.reject('');
      })
  }


  public signInFromSession() {
    return new Promise((resolve) => {
      return this.amplifyControllerService.getAuth()
        .then(Auth => {
          return Auth.currentSession();
        })
        .then(signInUserSession => {
          console.log(signInUserSession);
          console.log('processLogin id: ', signInUserSession.getIdToken().payload.sub);
          const idToken = signInUserSession.getIdToken();
          this.storageService.write('NAPersonal-isLog', 1);
          this.setIsLoggedIn(true);
          // alert(JSON.stringify(idToken.payload));
          const userInfo = {
            userid: idToken.payload.email,
            name: idToken.payload.nickname,
            username: idToken.payload['cognito:username'],
            isactive: idToken.payload.email_verified,
            id: idToken.payload.sub,
            rst: 'OK'
          };
          let loginProvider = localStorage.getItem('LoginProvider');
          if (loginProvider && loginProvider === 'federated') {
            localStorage.setItem('CordovaFederatedUserName', idToken.payload['cognito:username']);
          }
          // alert(idToken.payload['cognito:username']);
          this.storageService.write('NAPersonal-userinfo', userInfo);
          // window.location.reload();
          this.init();
          return resolve(null);
        })
        .catch(err => {
          console.log('processPersonal err ', err);
        });
    });
  }
}
